import { FieldProps } from 'formik';
import { ReactNode } from 'react';

import { Checkbox, ICheckboxProps } from 'libs/mui';

//FieldProps & ICheckboxProps
export const CheckboxField = (props: FieldProps & ICheckboxProps): ReactNode => {
  const {
    field,
    form: { touched, errors },
    meta,
    ...rest
  } = props;

  const name = field.name;
  const error = touched[name] && Boolean(errors[name]);
  if (error) {
    rest.color = 'error';
  }
  rest.checked = field.value;
  return <Checkbox {...field} {...rest}  />;
  
};

export default CheckboxField;
